/* OPTIQ - drawers, focus management, scroll lock, accordions.
   No dependencies. Each block is guarded so a missing section cannot throw. */
(function () {
  'use strict';

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function focusableIn(root) {
    return $$(FOCUSABLE, root).filter(function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0;
    });
  }

  /* Re-announces an identical string by clearing the region first. */
  window.optiqAnnounce = function (msg) {
    var region = $('[data-o-live]');
    if (!region || !msg) return;
    region.textContent = '';
    setTimeout(function () { region.textContent = msg; }, 60);
  };

  /* --- Scroll lock. Fixing body loses scroll position, so store/restore it. --- */
  var lockedAt = 0;
  var lockCount = 0;

  function lockScroll() {
    if (lockCount++ > 0) return;
    lockedAt = window.scrollY || window.pageYOffset || 0;
    document.body.style.top = '-' + lockedAt + 'px';
    document.body.classList.add('o-scroll-locked');
  }

  function unlockScroll() {
    if (--lockCount > 0) return;
    lockCount = 0;
    document.body.classList.remove('o-scroll-locked');
    document.body.style.top = '';
    window.scrollTo(0, lockedAt);
  }

  /* --- Drawer controller --- */
  var openDrawers = [];

  function openDrawer(drawer, trigger) {
    if (!drawer || drawer.classList.contains('is-open')) return;
    var overlay = $('[data-o-overlay]');

    drawer.__returnFocus = trigger || document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-open');
    lockScroll();
    openDrawers.push(drawer);

    var toggle = drawer.getAttribute('data-o-drawer');
    $$('[data-o-drawer-open="' + toggle + '"]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'true');
    });

    // Focus the panel itself rather than the close button so screen readers
    // read the drawer title before the first control.
    var target = drawer.querySelector('[data-o-drawer-focus]') || drawer;
    setTimeout(function () { target.focus({ preventScroll: true }); }, 40);
  }

  function closeDrawer(drawer) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');

    var toggle = drawer.getAttribute('data-o-drawer');
    $$('[data-o-drawer-open="' + toggle + '"]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
    });

    openDrawers = openDrawers.filter(function (d) { return d !== drawer; });
    if (!openDrawers.length) {
      var overlay = $('[data-o-overlay]');
      if (overlay) overlay.classList.remove('is-open');
    }
    unlockScroll();

    if (drawer.__returnFocus && document.contains(drawer.__returnFocus)) {
      drawer.__returnFocus.focus({ preventScroll: true });
    }
  }

  window.optiqOpenDrawer = function (name, trigger) {
    openDrawer($('[data-o-drawer="' + name + '"]'), trigger);
  };
  window.optiqCloseDrawers = function () {
    openDrawers.slice().forEach(closeDrawer);
  };

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-o-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer($('[data-o-drawer="' + opener.getAttribute('data-o-drawer-open') + '"]'), opener);
      return;
    }
    if (e.target.closest('[data-o-drawer-close]') || e.target.closest('[data-o-overlay]')) {
      e.preventDefault();
      var top = openDrawers[openDrawers.length - 1];
      if (top) closeDrawer(top);
    }
  });

  /* Escape closes the topmost drawer; Tab is trapped inside it. */
  document.addEventListener('keydown', function (e) {
    if (!openDrawers.length) return;
    var drawer = openDrawers[openDrawers.length - 1];

    if (e.key === 'Escape') {
      e.preventDefault();
      closeDrawer(drawer);
      return;
    }
    if (e.key !== 'Tab') return;

    var items = focusableIn(drawer);
    if (!items.length) { e.preventDefault(); return; }
    var first = items[0];
    var last = items[items.length - 1];

    if (e.shiftKey && (document.activeElement === first || document.activeElement === drawer)) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  /* --- Accordion. Uses grid-template-rows so content stays in flow. --- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-o-acc-trigger]');
    if (!trigger) return;

    var panel = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!panel) return;

    var isOpen = trigger.getAttribute('aria-expanded') === 'true';
    var group = trigger.closest('[data-o-acc]');

    if (group && group.getAttribute('data-o-acc-single') === 'true' && !isOpen) {
      $$('[data-o-acc-trigger][aria-expanded="true"]', group).forEach(function (other) {
        other.setAttribute('aria-expanded', 'false');
        var op = document.getElementById(other.getAttribute('aria-controls'));
        if (op) op.classList.remove('is-open');
      });
    }

    trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    panel.classList.toggle('is-open', !isOpen);
  });
})();
